// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductMainImage_container__CVtI5","productSinglePhoto":"ProductMainImage_productSinglePhoto__MWVx3","featureRowImage":"ProductMainImage_featureRowImage__UmyOd"};